import typeToReducer from 'type-to-reducer';
import set from 'lodash/set';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import { RESET_INPC_FORM, GET_INPC_BY_ID, MODIFY_EDITING_INPC } from 'inpc/constants';

export const initialState = {
  isFetchingConfig: false,
  isFetching: false,
  isSaving: false,
  editing: {
    values: { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0 },
  },
};

export const resetForm = (state) => ({ ...initialState });

export const getByIdPending = (state) => ({ ...state, isFetching: true });

export const getByIdRejected = (state) => ({ ...state, isFetching: false });

export const getByIdFulfilled = (state, { payload }) => ({
  ...state,
  isFetching: false,
  editing: { ...payload.inpc },
});

export const modifyInpc = (state, { payload }) => ({
  ...state,
  editing: {
    ...Object.keys(payload).reduce(
      (re, k) => {
        set(re, k, payload[k]);
        return re;
      },
      { ...state.editing }
    ),
  },
});

const reducers = {
  [RESET_INPC_FORM]: resetForm,
  [GET_INPC_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [MODIFY_EDITING_INPC]: modifyInpc,
};

export default typeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/inpc/reducers/inpc_form_reducers.js